export const COLOR_PURPLE = '#AF52DE';

export const COLOR_FREEMIUM = '#5856D6';
